export const SeniorMobile = () => {
  return (
    <div
      style={{
        boxSizing: "border-box",
        backgroundColor: "rgb(243, 243, 248)",
        minHeight: "100%",
      }}
      className="lg:hidden"
    >
      <div
        style={{
          boxSizing: "border-box",
          padding: "0px",
          width: "100%",
          marginLeft: "auto",
          marginRight: "auto",
          display: "block",
          paddingLeft: "0px",
          paddingRight: "0px",
          height: "auto",
        }}
      >
        <div
          style={{
            boxSizing: "border-box",
            display: "flex",
            flexFlow: "row wrap",
            width: "100%",
            WebkitBoxPack: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              boxSizing: "border-box",
              margin: "0px",
              flexDirection: "row",
              flexBasis: "100%",
              WebkitBoxFlex: 0,
              flexGrow: 0,
              maxWidth: "100%",
              padding: "0px 16px",
            }}
          >
            <div
              data-test="breadcrumb"
              style={{
                boxSizing: "border-box",
                margin: "0px 0px 0px",
                fontFamily: "Avenir",
                fontSize: "16px",
                lineHeight: "22px",
                fontWeight: 500,
                color: "rgb(94, 104, 120)",
                padding: "0px",
              }}
            >
              <ol
                style={{
                  boxSizing: "border-box",
                  display: "flex",
                  flexWrap: "wrap",
                  WebkitBoxAlign: "center",
                  alignItems: "center",
                  padding: "0px",
                  margin: "0px",
                  listStyle: "outside none none",
                }}
              >
                <li style={{ boxSizing: "border-box" }}>
                  <a
                    href="/app"
                    style={{
                      boxSizing: "border-box",
                      backgroundColor: "rgba(0, 0, 0, 0)",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "13px",
                      lineHeight: "18px",
                      fontWeight: 500,
                      color: "rgb(20, 112, 138)",
                      textDecoration: "none solid rgb(20, 112, 138)",
                      cursor: "pointer",
                      position: "relative",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      display: "inline-flex",
                      padding: "0px",
                    }}
                  >
                    Accueil
                  </a>
                </li>
                <li
                  aria-hidden="true"
                  style={{
                    boxSizing: "border-box",
                    display: "flex",
                    userSelect: "none",
                    marginLeft: "8px",
                    marginRight: "8px",
                  }}
                >
                  <svg
                    aria-hidden="true"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                      boxSizing: "border-box",
                      height: "13px",
                      margin: "2px -8px 0px",
                      width: "1.25rem",
                    }}
                  >
                    <path
                      d="M8.79362 6.6659C8.36568 7.06175 8.36568 7.73825 8.79362 8.1341L12.973 12L8.79362 15.8659C8.36568 16.2617 8.36568 16.9383 8.79362 17.3341L8.83447 17.3719C9.21775 17.7264 9.80928 17.7264 10.1926 17.3719L15.2064 12.7341C15.6343 12.3383 15.6343 11.6617 15.2064 11.2659L10.1926 6.62811C9.80928 6.27358 9.21775 6.27358 8.83447 6.62811L8.79362 6.6659Z"
                      style={{ boxSizing: "border-box" }}
                    ></path>
                  </svg>
                </li>
                <li style={{ boxSizing: "border-box" }}>
                  <a
                    href="/app/offre"
                    style={{
                      boxSizing: "border-box",
                      backgroundColor: "rgba(0, 0, 0, 0)",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "13px",
                      lineHeight: "18px",
                      fontWeight: 500,
                      color: "rgb(20, 112, 138)",
                      textDecoration: "none solid rgb(20, 112, 138)",
                      cursor: "pointer",
                      position: "relative",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      display: "inline-flex",
                      padding: "0px",
                    }}
                  >
                    Offres
                  </a>
                </li>
                <li
                  aria-hidden="true"
                  style={{
                    boxSizing: "border-box",
                    display: "flex",
                    userSelect: "none",
                    marginLeft: "8px",
                    marginRight: "8px",
                  }}
                >
                  <svg
                    aria-hidden="true"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                      boxSizing: "border-box",
                      height: "13px",
                      margin: "2px -8px 0px",
                      width: "1.25rem",
                    }}
                  >
                    <path
                      d="M8.79362 6.6659C8.36568 7.06175 8.36568 7.73825 8.79362 8.1341L12.973 12L8.79362 15.8659C8.36568 16.2617 8.36568 16.9383 8.79362 17.3341L8.83447 17.3719C9.21775 17.7264 9.80928 17.7264 10.1926 17.3719L15.2064 12.7341C15.6343 12.3383 15.6343 11.6617 15.2064 11.2659L10.1926 6.62811C9.80928 6.27358 9.21775 6.27358 8.83447 6.62811L8.79362 6.6659Z"
                      style={{ boxSizing: "border-box" }}
                    ></path>
                  </svg>
                </li>
                <li style={{ boxSizing: "border-box" }}>
                  <p
                    aria-current="page"
                    style={{
                      boxSizing: "border-box",
                      margin: "2px 0px 0px",
                      fontFamily: "Avenir",
                      fontSize: "13px",
                      lineHeight: "18px",
                      fontWeight: 500,
                      color: "rgb(12, 19, 31)",
                    }}
                  >
                    Carte Avantage Senior
                  </p>
                </li>
              </ol>
            </div>
            <div
              style={{
                boxSizing: "border-box",
                WebkitBoxAlign: "center",
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
                marginTop: "40px",
                paddingBottom: "16px",
              }}
            >
              <div
                style={{
                  boxSizing: "border-box",
                  alignSelf: "start",
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: "32px",
                }}
              >
                <h2
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0px 16px",
                    fontFamily: "Avenir",
                    fontSize: "20px",
                    lineHeight: "26px",
                    fontWeight: 800,
                  }}
                >
                  Carte Avantage Senior
                </h2>
                <p
                  style={{
                    maxWidth: "628px",
                    fontSize: "16px",
                    lineHeight: "22px",
                    boxSizing: "border-box",
                    margin: "0px",
                    fontFamily: "Avenir",
                    fontWeight: 500,
                    whiteSpace: "pre-line",
                  }}
                >
                  Avec la Carte Avantage, bénéficiez de prix plafonnés* en 2nde
                  classe sur TGV INOUI et INTERCITÉS (de jour et places assises
                  de nuit) en direct, en dernière minute et même en période de
                  grands départs !
                </p>
                <br />
                <ul>
                  <li>- Pour vos trajets de moins d'1h30 = 2,45 € max</li>
                  <li>- Pour vos trajets entre 1h30 et 3h = 69 € max</li>
                  <li>- Pour vos trajets de plus de 3h = 89 € max</li>
                </ul>
              </div>
              <ul
                role="list"
                style={{
                  boxSizing: "border-box",
                  alignSelf: "start",
                  display: "flex",
                  flexDirection: "column",
                  listStyleType: "none",
                  margin: "0px",
                  padding: "0px",
                }}
              >
                <li
                  style={{
                    boxSizing: "border-box",
                    display: "flex",
                    flexFlow: "row nowrap",
                    marginBottom: "16px",
                  }}
                >
                  <div style={{ boxSizing: "border-box" }}>
                    <svg
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      data-test="majorAvantages-0"
                      style={{
                        boxSizing: "border-box",
                        fill: "rgb(12, 19, 31)",
                        marginRight: "16px",
                        height: "24px",
                        width: "24px",
                      }}
                    >
                      <path
                        d="M2.11377 19.4238C2.11373 19.3582 2.12664 19.2931 2.15175 19.2324C2.17687 19.1718 2.21369 19.1166 2.26013 19.0702C2.30657 19.0238 2.3617 18.9869 2.42238 18.9618C2.48306 18.9367 2.5481 18.9238 2.61377 18.9238H4.48486C5.53557 18.9234 6.5499 19.3086 7.33545 20.0063L7.51904 20.1694C8.12172 20.7048 8.89993 21.0003 9.70605 21H16.4829C16.7511 21 17.0083 20.8935 17.198 20.7038C17.3876 20.5142 17.4941 20.257 17.4941 19.9888C17.4941 19.7206 17.3876 19.4634 17.198 19.2737C17.0083 19.0841 16.7511 18.9775 16.4829 18.9775C16.3503 18.9775 16.2231 18.9249 16.1294 18.8311C16.0356 18.7373 15.9829 18.6101 15.9829 18.4775C15.9829 18.3449 16.0356 18.2178 16.1294 18.124C16.2231 18.0302 16.3503 17.9775 16.4829 17.9775H17.625C17.8933 17.9775 18.1505 17.871 18.3402 17.6813C18.5299 17.4916 18.6365 17.2343 18.6365 16.966C18.6365 16.6978 18.5299 16.4405 18.3402 16.2508C18.1505 16.0611 17.8933 15.9545 17.625 15.9545C17.4924 15.9545 17.3652 15.9019 17.2714 15.8081C17.1777 15.7143 17.125 15.5871 17.125 15.4545C17.125 15.3219 17.1777 15.1948 17.2714 15.101C17.3652 15.0072 17.4924 14.9545 17.625 14.9545C17.6759 14.9545 17.7238 14.9659 17.7737 14.9696C17.8074 14.9588 17.8422 14.9518 17.8774 14.9487H18.5703C18.8385 14.9487 19.0957 14.8421 19.2854 14.6525C19.475 14.4629 19.5815 14.2056 19.5815 13.9375C19.5815 13.6693 19.475 13.412 19.2854 13.2224C19.0957 13.0328 18.8385 12.9262 18.5703 12.9262C18.4377 12.9262 18.3105 12.8735 18.2168 12.7798C18.123 12.686 18.0703 12.5588 18.0703 12.4262C18.0703 12.2936 18.123 12.1664 18.2168 12.0727C18.3105 11.9789 18.4377 11.9262 18.5703 11.9262H19.875C20.1427 11.9254 20.3992 11.8184 20.5882 11.6288C20.7772 11.4392 20.8833 11.1825 20.8833 10.9147C20.8833 10.647 20.7772 10.3902 20.5882 10.2006C20.3992 10.011 20.1427 9.90411 19.875 9.90327H11.8501C11.7175 9.90327 11.5903 9.85059 11.4965 9.75682C11.4028 9.66306 11.3501 9.53588 11.3501 9.40327C11.3501 9.27066 11.4028 9.14349 11.4965 9.04972C11.5903 8.95595 11.7175 8.90327 11.8501 8.90327H12.4595L12.9727 4.41011C12.9588 4.03012 12.7976 3.67043 12.5232 3.40723C12.2488 3.14402 11.8827 2.99797 11.5024 3H10.3364C10.2973 3.00019 10.2593 3.01291 10.2279 3.03628C10.1966 3.05965 10.1735 3.09245 10.1621 3.12988L8.59131 8.35742C8.44535 8.85127 8.14303 9.2844 7.7298 9.5917C7.31657 9.899 6.81476 10.0639 6.2998 10.0615H3.26318C3.13057 10.0615 3.00339 10.0088 2.90963 9.91507C2.81586 9.82131 2.76318 9.69413 2.76318 9.56152C2.76318 9.42891 2.81586 9.30173 2.90963 9.20797C3.00339 9.1142 3.13057 9.06152 3.26318 9.06152H6.2998C6.59949 9.06295 6.89154 8.96703 7.13203 8.78818C7.37251 8.60934 7.54842 8.35725 7.6333 8.06982L9.2041 2.84229C9.27824 2.59943 9.42815 2.38667 9.63189 2.23512C9.83563 2.08357 10.0825 2.00118 10.3364 2H11.5024C12.1565 2.00069 12.7835 2.2608 13.246 2.72327C13.7084 3.18573 13.9685 3.81278 13.9692 4.4668L13.4653 8.90332H19.875C20.3735 8.90337 20.8542 9.08851 21.2239 9.42286C21.5937 9.75721 21.8261 10.2169 21.8761 10.7129C21.9261 11.2089 21.7902 11.7058 21.4946 12.1072C21.1991 12.5086 20.765 12.786 20.2766 12.8856C20.4346 13.1372 20.5343 13.4209 20.5684 13.716C20.6025 14.0111 20.5701 14.3101 20.4737 14.5911C20.3772 14.8721 20.2191 15.1279 20.0109 15.3398C19.8027 15.5518 19.5497 15.7144 19.2705 15.8159C19.4556 16.0779 19.5748 16.3807 19.618 16.6986C19.6613 17.0165 19.6273 17.3401 19.519 17.6421C19.4106 17.9441 19.2312 18.2155 18.9957 18.4335C18.7603 18.6514 18.4758 18.8094 18.1664 18.8941C18.365 19.1971 18.4778 19.5482 18.4929 19.9101C18.508 20.2721 18.4248 20.6313 18.2522 20.9498C18.0796 21.2683 17.824 21.5341 17.5124 21.719C17.2009 21.9039 16.8452 22.001 16.4829 22H9.70605C8.6552 22.0005 7.64073 21.6153 6.855 20.9175L6.67141 20.7544C6.06887 20.2191 5.29084 19.9236 4.48488 19.9238H2.61377C2.5481 19.9239 2.48306 19.911 2.42238 19.8858C2.3617 19.8607 2.30657 19.8239 2.26013 19.7775C2.21369 19.731 2.17687 19.6759 2.15175 19.6152C2.12664 19.5545 2.11373 19.4895 2.11377 19.4238Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                    </svg>
                  </div>
                  <p
                    aria-hidden="true"
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "18px",
                      lineHeight: "24px",
                      fontWeight: 800,
                      maxWidth: "300px",
                    }}
                  >
                    - 30% sur vos voyages toute l'année en 2nde et en 1ère*
                  </p>
                  <span
                    style={{
                      boxSizing: "border-box",
                      fontFamily: "Avenir",
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontWeight: 500,
                      border: "0px none rgb(12, 19, 31)",
                      clip: "rect(0px, 0px, 0px, 0px)",
                      height: "1px",
                      margin: "-1px",
                      overflow: "hidden",
                      padding: "0px",
                      position: "absolute",
                      whiteSpace: "nowrap",
                      width: "1px",
                    }}
                  >
                    - 30% sur vos voyages toute l'année en 2nde et en 1ère*
                  </span>
                </li>
                <li
                  style={{
                    boxSizing: "border-box",
                    display: "flex",
                    flexFlow: "row nowrap",
                    marginBottom: "16px",
                  }}
                >
                  <div style={{ boxSizing: "border-box" }}>
                    <svg
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      data-test="majorAvantages-1"
                      style={{
                        boxSizing: "border-box",
                        fill: "rgb(12, 19, 31)",
                        marginRight: "16px",
                        height: "24px",
                        width: "24px",
                      }}
                    >
                      <path
                        d="M2.11377 19.4238C2.11373 19.3582 2.12664 19.2931 2.15175 19.2324C2.17687 19.1718 2.21369 19.1166 2.26013 19.0702C2.30657 19.0238 2.3617 18.9869 2.42238 18.9618C2.48306 18.9367 2.5481 18.9238 2.61377 18.9238H4.48486C5.53557 18.9234 6.5499 19.3086 7.33545 20.0063L7.51904 20.1694C8.12172 20.7048 8.89993 21.0003 9.70605 21H16.4829C16.7511 21 17.0083 20.8935 17.198 20.7038C17.3876 20.5142 17.4941 20.257 17.4941 19.9888C17.4941 19.7206 17.3876 19.4634 17.198 19.2737C17.0083 19.0841 16.7511 18.9775 16.4829 18.9775C16.3503 18.9775 16.2231 18.9249 16.1294 18.8311C16.0356 18.7373 15.9829 18.6101 15.9829 18.4775C15.9829 18.3449 16.0356 18.2178 16.1294 18.124C16.2231 18.0302 16.3503 17.9775 16.4829 17.9775H17.625C17.8933 17.9775 18.1505 17.871 18.3402 17.6813C18.5299 17.4916 18.6365 17.2343 18.6365 16.966C18.6365 16.6978 18.5299 16.4405 18.3402 16.2508C18.1505 16.0611 17.8933 15.9545 17.625 15.9545C17.4924 15.9545 17.3652 15.9019 17.2714 15.8081C17.1777 15.7143 17.125 15.5871 17.125 15.4545C17.125 15.3219 17.1777 15.1948 17.2714 15.101C17.3652 15.0072 17.4924 14.9545 17.625 14.9545C17.6759 14.9545 17.7238 14.9659 17.7737 14.9696C17.8074 14.9588 17.8422 14.9518 17.8774 14.9487H18.5703C18.8385 14.9487 19.0957 14.8421 19.2854 14.6525C19.475 14.4629 19.5815 14.2056 19.5815 13.9375C19.5815 13.6693 19.475 13.412 19.2854 13.2224C19.0957 13.0328 18.8385 12.9262 18.5703 12.9262C18.4377 12.9262 18.3105 12.8735 18.2168 12.7798C18.123 12.686 18.0703 12.5588 18.0703 12.4262C18.0703 12.2936 18.123 12.1664 18.2168 12.0727C18.3105 11.9789 18.4377 11.9262 18.5703 11.9262H19.875C20.1427 11.9254 20.3992 11.8184 20.5882 11.6288C20.7772 11.4392 20.8833 11.1825 20.8833 10.9147C20.8833 10.647 20.7772 10.3902 20.5882 10.2006C20.3992 10.011 20.1427 9.90411 19.875 9.90327H11.8501C11.7175 9.90327 11.5903 9.85059 11.4965 9.75682C11.4028 9.66306 11.3501 9.53588 11.3501 9.40327C11.3501 9.27066 11.4028 9.14349 11.4965 9.04972C11.5903 8.95595 11.7175 8.90327 11.8501 8.90327H12.4595L12.9727 4.41011C12.9588 4.03012 12.7976 3.67043 12.5232 3.40723C12.2488 3.14402 11.8827 2.99797 11.5024 3H10.3364C10.2973 3.00019 10.2593 3.01291 10.2279 3.03628C10.1966 3.05965 10.1735 3.09245 10.1621 3.12988L8.59131 8.35742C8.44535 8.85127 8.14303 9.2844 7.7298 9.5917C7.31657 9.899 6.81476 10.0639 6.2998 10.0615H3.26318C3.13057 10.0615 3.00339 10.0088 2.90963 9.91507C2.81586 9.82131 2.76318 9.69413 2.76318 9.56152C2.76318 9.42891 2.81586 9.30173 2.90963 9.20797C3.00339 9.1142 3.13057 9.06152 3.26318 9.06152H6.2998C6.59949 9.06295 6.89154 8.96703 7.13203 8.78818C7.37251 8.60934 7.54842 8.35725 7.6333 8.06982L9.2041 2.84229C9.27824 2.59943 9.42815 2.38667 9.63189 2.23512C9.83563 2.08357 10.0825 2.00118 10.3364 2H11.5024C12.1565 2.00069 12.7835 2.2608 13.246 2.72327C13.7084 3.18573 13.9685 3.81278 13.9692 4.4668L13.4653 8.90332H19.875C20.3735 8.90337 20.8542 9.08851 21.2239 9.42286C21.5937 9.75721 21.8261 10.2169 21.8761 10.7129C21.9261 11.2089 21.7902 11.7058 21.4946 12.1072C21.1991 12.5086 20.765 12.786 20.2766 12.8856C20.4346 13.1372 20.5343 13.4209 20.5684 13.716C20.6025 14.0111 20.5701 14.3101 20.4737 14.5911C20.3772 14.8721 20.2191 15.1279 20.0109 15.3398C19.8027 15.5518 19.5497 15.7144 19.2705 15.8159C19.4556 16.0779 19.5748 16.3807 19.618 16.6986C19.6613 17.0165 19.6273 17.3401 19.519 17.6421C19.4106 17.9441 19.2312 18.2155 18.9957 18.4335C18.7603 18.6514 18.4758 18.8094 18.1664 18.8941C18.365 19.1971 18.4778 19.5482 18.4929 19.9101C18.508 20.2721 18.4248 20.6313 18.2522 20.9498C18.0796 21.2683 17.824 21.5341 17.5124 21.719C17.2009 21.9039 16.8452 22.001 16.4829 22H9.70605C8.6552 22.0005 7.64073 21.6153 6.855 20.9175L6.67141 20.7544C6.06887 20.2191 5.29084 19.9236 4.48488 19.9238H2.61377C2.5481 19.9239 2.48306 19.911 2.42238 19.8858C2.3617 19.8607 2.30657 19.8239 2.26013 19.7775C2.21369 19.731 2.17687 19.6759 2.15175 19.6152C2.12664 19.5545 2.11373 19.4895 2.11377 19.4238Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                    </svg>
                  </div>
                  <p
                    aria-hidden="true"
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "18px",
                      lineHeight: "24px",
                      fontWeight: 800,
                      maxWidth: "300px",
                    }}
                  >
                    - 60% sur les billets de 3 enfants accompagnants par trajet*
                  </p>
                  <span
                    style={{
                      boxSizing: "border-box",
                      fontFamily: "Avenir",
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontWeight: 500,
                      border: "0px none rgb(12, 19, 31)",
                      clip: "rect(0px, 0px, 0px, 0px)",
                      height: "1px",
                      margin: "-1px",
                      overflow: "hidden",
                      padding: "0px",
                      position: "absolute",
                      whiteSpace: "nowrap",
                      width: "1px",
                    }}
                  >
                    - 60% sur les billets de 3 enfants accompagnants par trajet*
                  </span>
                </li>
                <li
                  style={{
                    boxSizing: "border-box",
                    display: "flex",
                    flexFlow: "row nowrap",
                    marginBottom: "16px",
                  }}
                >
                  <div style={{ boxSizing: "border-box" }}>
                    <svg
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      data-test="majorAvantages-2"
                      style={{
                        boxSizing: "border-box",
                        fill: "rgb(12, 19, 31)",
                        marginRight: "16px",
                        height: "24px",
                        width: "24px",
                      }}
                    >
                      <path
                        d="M2.11377 19.4238C2.11373 19.3582 2.12664 19.2931 2.15175 19.2324C2.17687 19.1718 2.21369 19.1166 2.26013 19.0702C2.30657 19.0238 2.3617 18.9869 2.42238 18.9618C2.48306 18.9367 2.5481 18.9238 2.61377 18.9238H4.48486C5.53557 18.9234 6.5499 19.3086 7.33545 20.0063L7.51904 20.1694C8.12172 20.7048 8.89993 21.0003 9.70605 21H16.4829C16.7511 21 17.0083 20.8935 17.198 20.7038C17.3876 20.5142 17.4941 20.257 17.4941 19.9888C17.4941 19.7206 17.3876 19.4634 17.198 19.2737C17.0083 19.0841 16.7511 18.9775 16.4829 18.9775C16.3503 18.9775 16.2231 18.9249 16.1294 18.8311C16.0356 18.7373 15.9829 18.6101 15.9829 18.4775C15.9829 18.3449 16.0356 18.2178 16.1294 18.124C16.2231 18.0302 16.3503 17.9775 16.4829 17.9775H17.625C17.8933 17.9775 18.1505 17.871 18.3402 17.6813C18.5299 17.4916 18.6365 17.2343 18.6365 16.966C18.6365 16.6978 18.5299 16.4405 18.3402 16.2508C18.1505 16.0611 17.8933 15.9545 17.625 15.9545C17.4924 15.9545 17.3652 15.9019 17.2714 15.8081C17.1777 15.7143 17.125 15.5871 17.125 15.4545C17.125 15.3219 17.1777 15.1948 17.2714 15.101C17.3652 15.0072 17.4924 14.9545 17.625 14.9545C17.6759 14.9545 17.7238 14.9659 17.7737 14.9696C17.8074 14.9588 17.8422 14.9518 17.8774 14.9487H18.5703C18.8385 14.9487 19.0957 14.8421 19.2854 14.6525C19.475 14.4629 19.5815 14.2056 19.5815 13.9375C19.5815 13.6693 19.475 13.412 19.2854 13.2224C19.0957 13.0328 18.8385 12.9262 18.5703 12.9262C18.4377 12.9262 18.3105 12.8735 18.2168 12.7798C18.123 12.686 18.0703 12.5588 18.0703 12.4262C18.0703 12.2936 18.123 12.1664 18.2168 12.0727C18.3105 11.9789 18.4377 11.9262 18.5703 11.9262H19.875C20.1427 11.9254 20.3992 11.8184 20.5882 11.6288C20.7772 11.4392 20.8833 11.1825 20.8833 10.9147C20.8833 10.647 20.7772 10.3902 20.5882 10.2006C20.3992 10.011 20.1427 9.90411 19.875 9.90327H11.8501C11.7175 9.90327 11.5903 9.85059 11.4965 9.75682C11.4028 9.66306 11.3501 9.53588 11.3501 9.40327C11.3501 9.27066 11.4028 9.14349 11.4965 9.04972C11.5903 8.95595 11.7175 8.90327 11.8501 8.90327H12.4595L12.9727 4.41011C12.9588 4.03012 12.7976 3.67043 12.5232 3.40723C12.2488 3.14402 11.8827 2.99797 11.5024 3H10.3364C10.2973 3.00019 10.2593 3.01291 10.2279 3.03628C10.1966 3.05965 10.1735 3.09245 10.1621 3.12988L8.59131 8.35742C8.44535 8.85127 8.14303 9.2844 7.7298 9.5917C7.31657 9.899 6.81476 10.0639 6.2998 10.0615H3.26318C3.13057 10.0615 3.00339 10.0088 2.90963 9.91507C2.81586 9.82131 2.76318 9.69413 2.76318 9.56152C2.76318 9.42891 2.81586 9.30173 2.90963 9.20797C3.00339 9.1142 3.13057 9.06152 3.26318 9.06152H6.2998C6.59949 9.06295 6.89154 8.96703 7.13203 8.78818C7.37251 8.60934 7.54842 8.35725 7.6333 8.06982L9.2041 2.84229C9.27824 2.59943 9.42815 2.38667 9.63189 2.23512C9.83563 2.08357 10.0825 2.00118 10.3364 2H11.5024C12.1565 2.00069 12.7835 2.2608 13.246 2.72327C13.7084 3.18573 13.9685 3.81278 13.9692 4.4668L13.4653 8.90332H19.875C20.3735 8.90337 20.8542 9.08851 21.2239 9.42286C21.5937 9.75721 21.8261 10.2169 21.8761 10.7129C21.9261 11.2089 21.7902 11.7058 21.4946 12.1072C21.1991 12.5086 20.765 12.786 20.2766 12.8856C20.4346 13.1372 20.5343 13.4209 20.5684 13.716C20.6025 14.0111 20.5701 14.3101 20.4737 14.5911C20.3772 14.8721 20.2191 15.1279 20.0109 15.3398C19.8027 15.5518 19.5497 15.7144 19.2705 15.8159C19.4556 16.0779 19.5748 16.3807 19.618 16.6986C19.6613 17.0165 19.6273 17.3401 19.519 17.6421C19.4106 17.9441 19.2312 18.2155 18.9957 18.4335C18.7603 18.6514 18.4758 18.8094 18.1664 18.8941C18.365 19.1971 18.4778 19.5482 18.4929 19.9101C18.508 20.2721 18.4248 20.6313 18.2522 20.9498C18.0796 21.2683 17.824 21.5341 17.5124 21.719C17.2009 21.9039 16.8452 22.001 16.4829 22H9.70605C8.6552 22.0005 7.64073 21.6153 6.855 20.9175L6.67141 20.7544C6.06887 20.2191 5.29084 19.9236 4.48488 19.9238H2.61377C2.5481 19.9239 2.48306 19.911 2.42238 19.8858C2.3617 19.8607 2.30657 19.8239 2.26013 19.7775C2.21369 19.731 2.17687 19.6759 2.15175 19.6152C2.12664 19.5545 2.11373 19.4895 2.11377 19.4238Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                    </svg>
                  </div>
                  <p
                    aria-hidden="true"
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "18px",
                      lineHeight: "24px",
                      fontWeight: 800,
                      maxWidth: "300px",
                    }}
                  >
                    -15% sur les services SNCF
                  </p>
                  <span
                    style={{
                      boxSizing: "border-box",
                      fontFamily: "Avenir",
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontWeight: 500,
                      border: "0px none rgb(12, 19, 31)",
                      clip: "rect(0px, 0px, 0px, 0px)",
                      height: "1px",
                      margin: "-1px",
                      overflow: "hidden",
                      padding: "0px",
                      position: "absolute",
                      whiteSpace: "nowrap",
                      width: "1px",
                    }}
                  >
                    {" "}
                    moins 15% sur les services SNCF
                  </span>
                </li>
              </ul>
            </div>
            <hr
              aria-hidden="true"
              style={{
                boxSizing: "content-box",
                height: "8px",
                overflow: "visible",
                margin: "0px",
                flexShrink: 0,
                borderWidth: "0px",
                borderColor: "rgb(173, 255, 47)",
                backgroundColor: "rgb(255, 255, 255)",
                borderStyle: "none",
              }}
            />
            <div style={{ boxSizing: "border-box", marginTop: "32px" }}>
              <div
                data-test="avantagesBlock"
                style={{
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "column",
                  margin: "32px 0px 24px",
                }}
              >
                <h2
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0px 24px",
                    fontFamily: "Avenir",
                    fontSize: "20px",
                    lineHeight: "26px",
                    fontWeight: 800,
                  }}
                >
                  Carte rentabilisée dès le 3e voyage
                </h2>
                <div
                  style={{
                    boxSizing: "border-box",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div style={{ boxSizing: "border-box", flexShrink: 0 }}>
                    <div
                      style={{
                        display: "block",
                        boxSizing: "border-box",
                        height: "197.422px",
                        width: "100%",
                      }}
                    >
                      <img
                        alt=""
                        src="https://www.sncf-connect.com/assets/styles/scale_and_crop_328x218/public/media/2022-01/bloc-avantages.png?itok=CwhTu7Pl"
                        style={{
                          boxSizing: "border-box",
                          borderStyle: "none",
                          borderRadius: "24px",
                          height: "191.406px",
                          width: "100%",
                        }}
                      />
                    </div>
                    <div
                      style={{
                        display: "none",
                        boxSizing: "border-box",
                        height: "100%",
                        width: "100%",
                      }}
                    >
                      <img
                        alt=""
                        src="https://www.sncf-connect.com/assets/styles/scale_and_crop_410x218/public/media/2022-01/bloc-avantages.png?itok=delBFn48"
                        style={{
                          boxSizing: "border-box",
                          borderStyle: "none",
                          borderRadius: "24px",
                          height: "100%",
                          width: "100%",
                        }}
                      />
                    </div>
                  </div>
                  <ul
                    role="list"
                    style={{
                      boxSizing: "border-box",
                      display: "flex",
                      flexFlow: "column wrap",
                      WebkitBoxPack: "justify",
                      justifyContent: "space-between",
                      listStyle: "outside none none",
                      margin: "0px 0px 0px",
                      padding: "0px",
                    }}
                  >
                    <li
                      style={{
                        boxSizing: "border-box",
                        gridArea: "content1",
                        alignSelf: "start",
                        display: "flex",
                        flexFlow: "row nowrap",
                        margin: "0px 0px 24px",
                        padding: "0px",
                      }}
                    >
                      <div style={{ boxSizing: "border-box" }}>
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          data-test="iconAvantages"
                          style={{
                            boxSizing: "border-box",
                            marginRight: "16px",
                            height: "20px",
                            width: "20px",
                          }}
                        >
                          <path
                            d="M21.5766 9.26017L15.4544 8.32781C15.3966 8.31763 15.3421 8.29341 15.2958 8.25727C15.2494 8.22112 15.2127 8.17416 15.1887 8.12051L12.4505 2.30782C12.4052 2.22824 12.3397 2.16207 12.2605 2.11605C12.1814 2.07002 12.0915 2.04578 11.9999 2.04578C11.9084 2.04578 11.8184 2.07002 11.7393 2.11605C11.6601 2.16207 11.5946 2.22824 11.5493 2.30782L8.81061 8.12099C8.78687 8.17446 8.75035 8.22129 8.70428 8.25735C8.65821 8.29341 8.60398 8.31761 8.54637 8.32781L2.42322 9.26017C2.3326 9.27397 2.24756 9.31251 2.17743 9.37153C2.1073 9.43055 2.05481 9.50777 2.02573 9.5947C1.99666 9.68162 1.99212 9.77488 2.01263 9.86422C2.03313 9.95356 2.07788 10.0355 2.14195 10.1011L6.57264 14.6257C6.61766 14.673 6.65097 14.7302 6.66989 14.7928C6.68882 14.8553 6.69284 14.9214 6.68164 14.9858L5.6354 21.3746C5.62376 21.4459 5.62777 21.5189 5.64714 21.5886C5.6665 21.6582 5.70077 21.7228 5.74757 21.7778C5.79436 21.8329 5.85256 21.8772 5.91815 21.9075C5.98373 21.9379 6.05513 21.9536 6.1274 21.9537C6.21153 21.9538 6.2943 21.9324 6.36779 21.8914L11.8437 18.8753C11.8914 18.8488 11.945 18.8348 11.9996 18.8347C12.0541 18.8345 12.1078 18.8481 12.1557 18.8743L17.6321 21.8914C17.714 21.9365 17.8069 21.9577 17.9002 21.9526C17.9936 21.9474 18.0836 21.9161 18.16 21.8622C18.2364 21.8083 18.2961 21.734 18.3323 21.6477C18.3684 21.5615 18.3796 21.4668 18.3645 21.3746L17.3182 14.9847C17.3071 14.9205 17.3111 14.8545 17.3302 14.7921C17.3492 14.7298 17.3826 14.6727 17.4277 14.6256L21.8579 10.101C21.922 10.0355 21.9667 9.95353 21.9872 9.86419C22.0077 9.77485 22.0032 9.68159 21.9741 9.59467C21.945 9.50774 21.8926 9.43052 21.8224 9.3715C21.7523 9.31248 21.6673 9.27394 21.5766 9.26014L21.5766 9.26017ZM16.7158 13.9283C16.5614 14.0874 16.4464 14.2804 16.3803 14.492C16.3141 14.7035 16.2985 14.9277 16.3348 15.1463L17.2151 20.524L12.6359 18.0013C12.441 17.8939 12.2221 17.8377 11.9995 17.8379C11.777 17.838 11.5581 17.8946 11.3634 18.0023L6.7848 20.524L7.66559 15.1463C7.70161 14.9278 7.68596 14.7038 7.61988 14.4924C7.5538 14.281 7.43913 14.088 7.28505 13.9288L3.53466 10.0986L8.69674 9.31273C8.91611 9.27812 9.12356 9.18994 9.30071 9.05599C9.47786 8.92205 9.61923 8.74648 9.71231 8.54484L11.9999 3.68934L14.2875 8.54534C14.3809 8.74693 14.5224 8.92242 14.6998 9.05627C14.8771 9.19012 15.0846 9.2782 15.3041 9.31274L20.4652 10.0986L16.7158 13.9283Z"
                            style={{ boxSizing: "border-box" }}
                          ></path>
                        </svg>
                      </div>
                      <div
                        style={{ boxSizing: "border-box", maxWidth: "370px" }}
                      >
                        <h3
                          style={{
                            boxSizing: "border-box",
                            margin: "0px 0px 4px",
                            fontFamily: "Avenir",
                            fontSize: "16px",
                            lineHeight: "22px",
                            fontWeight: 500,
                          }}
                        >
                          Des réductions tous les jours{" "}
                        </h3>
                        <p
                          style={{
                            boxSizing: "border-box",
                            margin: "0px",
                            fontFamily: "Avenir",
                            fontSize: "16px",
                            lineHeight: "22px",
                            fontWeight: 500,
                          }}
                        >
                          Profitez de vos réductions tous les jours de l'année,
                          même les jours de grands départs.
                        </p>
                      </div>
                    </li>
                    <li
                      style={{
                        boxSizing: "border-box",
                        gridArea: "content2",
                        alignSelf: "start",
                        display: "flex",
                        flexFlow: "row nowrap",
                        margin: "0px 0px 24px",
                        padding: "0px",
                      }}
                    >
                      <div style={{ boxSizing: "border-box" }}>
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          data-test="iconAvantages"
                          style={{
                            boxSizing: "border-box",
                            marginRight: "16px",
                            height: "20px",
                            width: "20px",
                          }}
                        >
                          <path
                            d="M21.5766 9.26017L15.4544 8.32781C15.3966 8.31763 15.3421 8.29341 15.2958 8.25727C15.2494 8.22112 15.2127 8.17416 15.1887 8.12051L12.4505 2.30782C12.4052 2.22824 12.3397 2.16207 12.2605 2.11605C12.1814 2.07002 12.0915 2.04578 11.9999 2.04578C11.9084 2.04578 11.8184 2.07002 11.7393 2.11605C11.6601 2.16207 11.5946 2.22824 11.5493 2.30782L8.81061 8.12099C8.78687 8.17446 8.75035 8.22129 8.70428 8.25735C8.65821 8.29341 8.60398 8.31761 8.54637 8.32781L2.42322 9.26017C2.3326 9.27397 2.24756 9.31251 2.17743 9.37153C2.1073 9.43055 2.05481 9.50777 2.02573 9.5947C1.99666 9.68162 1.99212 9.77488 2.01263 9.86422C2.03313 9.95356 2.07788 10.0355 2.14195 10.1011L6.57264 14.6257C6.61766 14.673 6.65097 14.7302 6.66989 14.7928C6.68882 14.8553 6.69284 14.9214 6.68164 14.9858L5.6354 21.3746C5.62376 21.4459 5.62777 21.5189 5.64714 21.5886C5.6665 21.6582 5.70077 21.7228 5.74757 21.7778C5.79436 21.8329 5.85256 21.8772 5.91815 21.9075C5.98373 21.9379 6.05513 21.9536 6.1274 21.9537C6.21153 21.9538 6.2943 21.9324 6.36779 21.8914L11.8437 18.8753C11.8914 18.8488 11.945 18.8348 11.9996 18.8347C12.0541 18.8345 12.1078 18.8481 12.1557 18.8743L17.6321 21.8914C17.714 21.9365 17.8069 21.9577 17.9002 21.9526C17.9936 21.9474 18.0836 21.9161 18.16 21.8622C18.2364 21.8083 18.2961 21.734 18.3323 21.6477C18.3684 21.5615 18.3796 21.4668 18.3645 21.3746L17.3182 14.9847C17.3071 14.9205 17.3111 14.8545 17.3302 14.7921C17.3492 14.7298 17.3826 14.6727 17.4277 14.6256L21.8579 10.101C21.922 10.0355 21.9667 9.95353 21.9872 9.86419C22.0077 9.77485 22.0032 9.68159 21.9741 9.59467C21.945 9.50774 21.8926 9.43052 21.8224 9.3715C21.7523 9.31248 21.6673 9.27394 21.5766 9.26014L21.5766 9.26017ZM16.7158 13.9283C16.5614 14.0874 16.4464 14.2804 16.3803 14.492C16.3141 14.7035 16.2985 14.9277 16.3348 15.1463L17.2151 20.524L12.6359 18.0013C12.441 17.8939 12.2221 17.8377 11.9995 17.8379C11.777 17.838 11.5581 17.8946 11.3634 18.0023L6.7848 20.524L7.66559 15.1463C7.70161 14.9278 7.68596 14.7038 7.61988 14.4924C7.5538 14.281 7.43913 14.088 7.28505 13.9288L3.53466 10.0986L8.69674 9.31273C8.91611 9.27812 9.12356 9.18994 9.30071 9.05599C9.47786 8.92205 9.61923 8.74648 9.71231 8.54484L11.9999 3.68934L14.2875 8.54534C14.3809 8.74693 14.5224 8.92242 14.6998 9.05627C14.8771 9.19012 15.0846 9.2782 15.3041 9.31274L20.4652 10.0986L16.7158 13.9283Z"
                            style={{ boxSizing: "border-box" }}
                          ></path>
                        </svg>
                      </div>
                      <div
                        style={{ boxSizing: "border-box", maxWidth: "370px" }}
                      >
                        <h3
                          style={{
                            boxSizing: "border-box",
                            margin: "0px 0px 4px",
                            fontFamily: "Avenir",
                            fontSize: "16px",
                            lineHeight: "22px",
                            fontWeight: 500,
                          }}
                        >
                          Des offres de dernière minute*
                        </h3>
                        <p
                          style={{
                            boxSizing: "border-box",
                            margin: "0px",
                            fontFamily: "Avenir",
                            fontSize: "16px",
                            lineHeight: "22px",
                            fontWeight: 500,
                          }}
                        >
                          Profitez de tarifs exclusifs en dernière minute.
                        </p>
                      </div>
                    </li>
                    <li
                      style={{
                        boxSizing: "border-box",
                        gridArea: "content3",
                        alignSelf: "start",
                        display: "flex",
                        flexFlow: "row nowrap",
                        margin: "0px 0px 24px",
                        padding: "0px",
                      }}
                    >
                      <div style={{ boxSizing: "border-box" }}>
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          data-test="iconAvantages"
                          style={{
                            boxSizing: "border-box",
                            marginRight: "16px",
                            height: "20px",
                            width: "20px",
                          }}
                        >
                          <path
                            d="M21.5766 9.26017L15.4544 8.32781C15.3966 8.31763 15.3421 8.29341 15.2958 8.25727C15.2494 8.22112 15.2127 8.17416 15.1887 8.12051L12.4505 2.30782C12.4052 2.22824 12.3397 2.16207 12.2605 2.11605C12.1814 2.07002 12.0915 2.04578 11.9999 2.04578C11.9084 2.04578 11.8184 2.07002 11.7393 2.11605C11.6601 2.16207 11.5946 2.22824 11.5493 2.30782L8.81061 8.12099C8.78687 8.17446 8.75035 8.22129 8.70428 8.25735C8.65821 8.29341 8.60398 8.31761 8.54637 8.32781L2.42322 9.26017C2.3326 9.27397 2.24756 9.31251 2.17743 9.37153C2.1073 9.43055 2.05481 9.50777 2.02573 9.5947C1.99666 9.68162 1.99212 9.77488 2.01263 9.86422C2.03313 9.95356 2.07788 10.0355 2.14195 10.1011L6.57264 14.6257C6.61766 14.673 6.65097 14.7302 6.66989 14.7928C6.68882 14.8553 6.69284 14.9214 6.68164 14.9858L5.6354 21.3746C5.62376 21.4459 5.62777 21.5189 5.64714 21.5886C5.6665 21.6582 5.70077 21.7228 5.74757 21.7778C5.79436 21.8329 5.85256 21.8772 5.91815 21.9075C5.98373 21.9379 6.05513 21.9536 6.1274 21.9537C6.21153 21.9538 6.2943 21.9324 6.36779 21.8914L11.8437 18.8753C11.8914 18.8488 11.945 18.8348 11.9996 18.8347C12.0541 18.8345 12.1078 18.8481 12.1557 18.8743L17.6321 21.8914C17.714 21.9365 17.8069 21.9577 17.9002 21.9526C17.9936 21.9474 18.0836 21.9161 18.16 21.8622C18.2364 21.8083 18.2961 21.734 18.3323 21.6477C18.3684 21.5615 18.3796 21.4668 18.3645 21.3746L17.3182 14.9847C17.3071 14.9205 17.3111 14.8545 17.3302 14.7921C17.3492 14.7298 17.3826 14.6727 17.4277 14.6256L21.8579 10.101C21.922 10.0355 21.9667 9.95353 21.9872 9.86419C22.0077 9.77485 22.0032 9.68159 21.9741 9.59467C21.945 9.50774 21.8926 9.43052 21.8224 9.3715C21.7523 9.31248 21.6673 9.27394 21.5766 9.26014L21.5766 9.26017ZM16.7158 13.9283C16.5614 14.0874 16.4464 14.2804 16.3803 14.492C16.3141 14.7035 16.2985 14.9277 16.3348 15.1463L17.2151 20.524L12.6359 18.0013C12.441 17.8939 12.2221 17.8377 11.9995 17.8379C11.777 17.838 11.5581 17.8946 11.3634 18.0023L6.7848 20.524L7.66559 15.1463C7.70161 14.9278 7.68596 14.7038 7.61988 14.4924C7.5538 14.281 7.43913 14.088 7.28505 13.9288L3.53466 10.0986L8.69674 9.31273C8.91611 9.27812 9.12356 9.18994 9.30071 9.05599C9.47786 8.92205 9.61923 8.74648 9.71231 8.54484L11.9999 3.68934L14.2875 8.54534C14.3809 8.74693 14.5224 8.92242 14.6998 9.05627C14.8771 9.19012 15.0846 9.2782 15.3041 9.31274L20.4652 10.0986L16.7158 13.9283Z"
                            style={{ boxSizing: "border-box" }}
                          ></path>
                        </svg>
                      </div>
                      <div
                        style={{ boxSizing: "border-box", maxWidth: "370px" }}
                      >
                        <h3
                          style={{
                            boxSizing: "border-box",
                            margin: "0px 0px 4px",
                            fontFamily: "Avenir",
                            fontSize: "16px",
                            lineHeight: "22px",
                            fontWeight: 500,
                          }}
                        >
                          Des réductions sur nos services*
                        </h3>
                        <p
                          style={{
                            boxSizing: "border-box",
                            margin: "0px",
                            fontFamily: "Avenir",
                            fontSize: "16px",
                            lineHeight: "22px",
                            fontWeight: 500,
                          }}
                        >
                          15% de réduction sur nos services : Ma Location Avis,
                          Mes bagages, la restauration à bord et Junior &amp;
                          Cie.
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div
                style={{
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "column",
                  margin: "0px -16px 48px",
                }}
              >
                <h2
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0px 24px",
                    fontFamily: "Avenir",
                    fontSize: "20px",
                    lineHeight: "26px",
                    fontWeight: 800,
                    padding: "0px 16px",
                  }}
                >
                  Quelques informations complémentaires
                </h2>
                <div
                  style={{
                    boxSizing: "border-box",
                    display: "flex",
                    flexDirection: "column",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      boxSizing: "border-box",
                      height: "214px",
                      position: "relative",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "block",
                        boxSizing: "border-box",
                        height: "214px",
                        width: "100%",
                      }}
                    >
                      <img
                        alt=""
                        src="https://www.sncf-connect.com/assets/styles/scale_and_crop_380x214/public/media/2022-01/bloc-offres-2.png?itok=yyAm3xN0"
                        style={{
                          boxSizing: "border-box",
                          borderStyle: "none",
                          objectFit: "cover",
                          objectPosition: "50% 50%",
                          height: "214px",
                          width: "100%",
                        }}
                      />
                    </div>
                    <div
                      style={{
                        display: "none",
                        boxSizing: "border-box",
                        height: "100%",
                        width: "100%",
                      }}
                    >
                      <img
                        alt=""
                        src="https://www.sncf-connect.com/assets/styles/scale_and_crop_1275x256/public/media/2022-01/bloc-offres-2.png?itok=CiJnUf3Z"
                        style={{
                          boxSizing: "border-box",
                          borderStyle: "none",
                          objectFit: "cover",
                          objectPosition: "50% 50%",
                          height: "100%",
                          width: "100%",
                        }}
                      />
                    </div>
                  </div>
                  <ul
                    role="list"
                    style={{
                      boxSizing: "border-box",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      WebkitBoxPack: "center",
                      justifyContent: "center",
                      listStyle: "outside none none",
                      margin: "-88px 0px 0px",
                      padding: "0px 16px",
                      zIndex: 1,
                    }}
                  >
                    <li
                      style={{
                        boxSizing: "border-box",
                        marginBottom: "16px",
                        maxWidth: "328px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          color: "rgb(12, 19, 31)",
                          transition:
                            "box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          borderRadius: "14px",
                          overflow: "hidden",
                          boxShadow: "none",
                          border: "0px none rgb(12, 19, 31)",
                          background:
                            "rgb(255, 255, 255) none repeat scroll 0% 0% / auto padding-box border-box",
                          WebkitBoxAlign: "stretch",
                          alignItems: "stretch",
                          display: "flex",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            boxSizing: "border-box",
                            paddingBottom: "32px",
                            display: "flex",
                            flexDirection: "column",
                            WebkitBoxPack: "justify",
                            justifyContent: "space-between",
                            minHeight: "262px",
                            padding: "24px 16px 32px",
                          }}
                        >
                          <div style={{ boxSizing: "border-box" }}>
                            <h3
                              style={{
                                boxSizing: "border-box",
                                margin: "0px",
                                fontFamily: "Avenir",
                                fontSize: "16px",
                                lineHeight: "22px",
                                fontWeight: 500,
                                paddingBottom: "4px",
                              }}
                            >
                              TGV INOUI &amp; INTERCITÉS
                            </h3>
                            <p
                              style={{
                                boxSizing: "border-box",
                                margin: "0px",
                                fontFamily: "Avenir",
                                fontSize: "16px",
                                lineHeight: "22px",
                                fontWeight: 500,
                                color: "rgb(94, 104, 120)",
                                whiteSpace: "pre-line",
                              }}
                            >
                              - 30% sur vos voyages en TGV &amp; INTERCITÉS -
                              Des offres de dernière minute exclusives
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li
                      style={{
                        boxSizing: "border-box",
                        marginBottom: "16px",
                        maxWidth: "328px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          color: "rgb(12, 19, 31)",
                          transition:
                            "box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          borderRadius: "14px",
                          overflow: "hidden",
                          boxShadow: "none",
                          border: "0px none rgb(12, 19, 31)",
                          background:
                            "rgb(255, 255, 255) none repeat scroll 0% 0% / auto padding-box border-box",
                          WebkitBoxAlign: "stretch",
                          alignItems: "stretch",
                          display: "flex",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            boxSizing: "border-box",
                            paddingBottom: "32px",
                            display: "flex",
                            flexDirection: "column",
                            WebkitBoxPack: "justify",
                            justifyContent: "space-between",
                            minHeight: "262px",
                            padding: "24px 16px 32px",
                          }}
                        >
                          <div style={{ boxSizing: "border-box" }}>
                            <h3
                              style={{
                                boxSizing: "border-box",
                                margin: "0px",
                                fontFamily: "Avenir",
                                fontSize: "16px",
                                lineHeight: "22px",
                                fontWeight: 500,
                                paddingBottom: "4px",
                              }}
                            >
                              TER{" "}
                            </h3>
                            <p
                              style={{
                                boxSizing: "border-box",
                                margin: "0px",
                                fontFamily: "Avenir",
                                fontSize: "16px",
                                lineHeight: "22px",
                                fontWeight: 500,
                                color: "rgb(94, 104, 120)",
                                whiteSpace: "pre-line",
                              }}
                            >
                              - 25% ou - 50% sur vos billets en région
                              Occitanie, Bourgogne-Franche-Comté &amp;
                              Auvergne-Rhône-Alpes - 30% sur vos voyages en
                              région Bretagne, Normandie, Pays de la Loire &amp;
                              Nouvelle-Aquitaine - 25% sur vos trajets en
                              régions Hauts de France, Grand Est &amp; Centre
                              Val de Loire
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li
                      style={{
                        boxSizing: "border-box",
                        marginBottom: "16px",
                        maxWidth: "328px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          color: "rgb(12, 19, 31)",
                          transition:
                            "box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          borderRadius: "14px",
                          overflow: "hidden",
                          boxShadow: "none",
                          border: "0px none rgb(12, 19, 31)",
                          background:
                            "rgb(255, 255, 255) none repeat scroll 0% 0% / auto padding-box border-box",
                          WebkitBoxAlign: "stretch",
                          alignItems: "stretch",
                          display: "flex",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            boxSizing: "border-box",
                            paddingBottom: "32px",
                            display: "flex",
                            flexDirection: "column",
                            WebkitBoxPack: "justify",
                            justifyContent: "space-between",
                            minHeight: "262px",
                            padding: "24px 16px 32px",
                          }}
                        >
                          <div style={{ boxSizing: "border-box" }}>
                            <h3
                              style={{
                                boxSizing: "border-box",
                                margin: "0px",
                                fontFamily: "Avenir",
                                fontSize: "16px",
                                lineHeight: "22px",
                                fontWeight: 500,
                                paddingBottom: "4px",
                              }}
                            >
                              En Europe
                            </h3>
                            <p
                              style={{
                                boxSizing: "border-box",
                                margin: "0px",
                                fontFamily: "Avenir",
                                fontSize: "16px",
                                lineHeight: "22px",
                                fontWeight: 500,
                                color: "rgb(94, 104, 120)",
                                whiteSpace: "pre-line",
                              }}
                            >
                              - 30% sur vos voyages : - Vers le Luxembourg &amp;
                              Frisbourg-en-Brisgau avec TGV INOUI - Vers
                              l'Allemagne avec TGV INOUI et DB SNCF en
                              coopération - Vers la Suisse avec TGV Lyria - Vers
                              l'Italie avec TGV France-Italie - Vers l'Espagne
                              avec TGV INOUI France-Espagne
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div
                style={{
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "column",
                  margin: "32px 0px 24px",
                }}
              >
                <h2
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0px 24px",
                    fontFamily: "Avenir",
                    fontSize: "20px",
                    lineHeight: "26px",
                    fontWeight: 800,
                    padding: "0px 16px",
                  }}
                >
                  Comment se procurer une Carte Avantage ?
                </h2>
                <ol
                  style={{
                    boxSizing: "border-box",
                    display: "flex",
                    flexDirection: "column",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    margin: "0px 0px 16px",
                    padding: "0px",
                  }}
                >
                  <li style={{ boxSizing: "border-box", overflow: "hidden" }}>
                    <div
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        marginBottom: "24px",
                      }}
                    >
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        data-test="icon-1"
                        style={{
                          boxSizing: "border-box",
                          fill: "rgb(12, 19, 31)",
                          marginBottom: "16px",
                          height: "70px",
                          width: "4.375rem",
                        }}
                      >
                        <path
                          d="M12 2C6.49434 2 2 6.49438 2 12C2 17.5056 6.49434 22 12 22C17.5056 22 22 17.5056 22 12C22 6.49438 17.5056 2 12 2ZM12 20.8764C7.11232 20.8764 3.1236 16.8876 3.1236 12C3.1236 7.11236 7.11232 3.1236 12 3.1236C16.8876 3.1236 20.8764 7.11236 20.8764 12C20.8764 16.8876 16.8876 20.8764 12 20.8764Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M11.9194 10.2786L10.5161 11.1811L10 10.3203L12.1129 9H13V15H11.9194V10.2786Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                      </svg>
                      <p
                        style={{
                          boxSizing: "border-box",
                          margin: "0px 0px 4px",
                          fontFamily: "Avenir",
                          fontSize: "18px",
                          lineHeight: "24px",
                          fontWeight: 800,
                        }}
                      >
                        Achetez
                      </p>
                      <p
                        style={{
                          boxSizing: "border-box",
                          margin: "0px",
                          fontFamily: "Avenir",
                          fontSize: "16px",
                          lineHeight: "22px",
                          fontWeight: 500,
                          textAlign: "center",
                        }}
                      >
                        dès maintenant votre Carte Avantage sur SNCF Connect.
                      </p>
                    </div>
                  </li>
                  <li style={{ boxSizing: "border-box", overflow: "hidden" }}>
                    <div
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        marginBottom: "24px",
                      }}
                    >
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        data-test="icon-2"
                        style={{
                          boxSizing: "border-box",
                          fill: "rgb(12, 19, 31)",
                          marginBottom: "16px",
                          height: "70px",
                          width: "4.375rem",
                        }}
                      >
                        <path
                          d="M12 2C6.49434 2 2 6.49438 2 12C2 17.5056 6.49434 22 12 22C17.5056 22 22 17.5056 22 12C22 6.49438 17.5056 2 12 2ZM12 20.8764C7.11232 20.8764 3.1236 16.8876 3.1236 12C3.1236 7.11236 7.11232 3.1236 12 3.1236C16.8876 3.1236 20.8764 7.11236 20.8764 12C20.8764 16.8876 16.8876 20.8764 12 20.8764Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M10 15V14.4493C10 14.1753 10.0342 13.9288 10.1026 13.7096C10.1709 13.4904 10.2678 13.2904 10.3932 13.1096C10.5185 12.9288 10.6695 12.7616 10.8462 12.6082C11.0285 12.4548 11.2336 12.3041 11.4615 12.1562L11.9316 11.8603C12.0684 11.7671 12.1909 11.6849 12.2991 11.6137C12.4131 11.5425 12.5071 11.4658 12.5812 11.3836C12.661 11.3014 12.7208 11.2082 12.7607 11.1041C12.8063 10.9945 12.8291 10.863 12.8291 10.7096C12.8291 10.1507 12.5328 9.87123 11.9402 9.87123C11.661 9.87123 11.4188 9.93151 11.2137 10.0521C11.0085 10.1726 10.8148 10.3068 10.6325 10.4548L10.1197 9.60822C10.4729 9.38356 10.8063 9.2274 11.1197 9.13973C11.433 9.04658 11.7635 9 12.1111 9C12.6752 9 13.1254 9.14247 13.4615 9.4274C13.8034 9.71233 13.9744 10.137 13.9744 10.7014C13.9744 10.9479 13.9316 11.1616 13.8462 11.3425C13.7607 11.5233 13.6467 11.6849 13.5043 11.8274C13.3675 11.9699 13.2108 12.0986 13.0342 12.2137C12.8632 12.3288 12.6895 12.4438 12.5128 12.5589L11.9487 12.9288C11.6695 13.1041 11.4587 13.2877 11.3162 13.4795C11.1795 13.6658 11.0997 13.8548 11.0769 14.0466H14V15H10Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                      </svg>
                      <p
                        style={{
                          boxSizing: "border-box",
                          margin: "0px 0px 4px",
                          fontFamily: "Avenir",
                          fontSize: "18px",
                          lineHeight: "24px",
                          fontWeight: 800,
                        }}
                      >
                        Choisissez
                      </p>
                      <p
                        style={{
                          boxSizing: "border-box",
                          margin: "0px",
                          fontFamily: "Avenir",
                          fontSize: "16px",
                          lineHeight: "22px",
                          fontWeight: 500,
                          textAlign: "center",
                        }}
                      >
                        la date de début de validité de votre carte jusqu'à 5
                        mois par rapport à la date d'achat.
                      </p>
                    </div>
                  </li>
                  <li style={{ boxSizing: "border-box", overflow: "hidden" }}>
                    <div
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        marginBottom: "24px",
                      }}
                    >
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        data-test="icon-3"
                        style={{
                          boxSizing: "border-box",
                          fill: "rgb(12, 19, 31)",
                          marginBottom: "16px",
                          height: "70px",
                          width: "4.375rem",
                        }}
                      >
                        <path
                          d="M12 2C6.49434 2 2 6.49438 2 12C2 17.5056 6.49434 22 12 22C17.5056 22 22 17.5056 22 12C22 6.49438 17.5056 2 12 2ZM12 20.8764C7.11232 20.8764 3.1236 16.8876 3.1236 12C3.1236 7.11236 7.11232 3.1236 12 3.1236C16.8876 3.1236 20.8764 7.11236 20.8764 12C20.8764 16.8876 16.8876 20.8764 12 20.8764Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M14 13.0997C14 13.3962 13.9471 13.6631 13.8413 13.9003C13.7354 14.1321 13.5873 14.3315 13.3968 14.4987C13.2116 14.6604 12.9894 14.7844 12.7302 14.8706C12.4762 14.9569 12.1984 15 11.8968 15C11.4841 15 11.1217 14.9191 10.8095 14.7574C10.5026 14.5957 10.2328 14.3288 10 13.9569L10.7857 13.3585C10.9074 13.5957 11.0503 13.7898 11.2143 13.9407C11.3836 14.0863 11.6217 14.159 11.9286 14.159C12.2566 14.159 12.5079 14.0674 12.6825 13.8841C12.8624 13.6954 12.9524 13.4528 12.9524 13.1563C12.9524 12.8491 12.8571 12.6253 12.6667 12.4852C12.4815 12.3396 12.2381 12.2668 11.9365 12.2668C11.7037 12.2668 11.5079 12.283 11.3492 12.3154V11.4178H11.6111C11.7328 11.4178 11.8492 11.4151 11.9603 11.4097C12.0767 11.3989 12.1852 11.3747 12.2857 11.3369C12.418 11.2884 12.5238 11.2049 12.6032 11.0863C12.6825 10.9677 12.7222 10.7978 12.7222 10.5768C12.7222 10.3396 12.6455 10.159 12.4921 10.035C12.3439 9.90566 12.1402 9.84097 11.881 9.84097C11.7487 9.84097 11.6243 9.85714 11.5079 9.88949C11.3968 9.92183 11.2937 9.96496 11.1984 10.0189C11.1032 10.0674 11.0159 10.124 10.9365 10.1887C10.8624 10.248 10.7937 10.3046 10.7302 10.3585L10.2619 9.54986C10.5317 9.37197 10.8095 9.2372 11.0952 9.14555C11.3862 9.04852 11.6931 9 12.0159 9C12.254 9 12.4762 9.02965 12.6825 9.08895C12.8942 9.14286 13.0794 9.23181 13.2381 9.35579C13.3968 9.47439 13.5212 9.62534 13.6111 9.80863C13.7063 9.98652 13.754 10.2022 13.754 10.4555C13.754 10.6065 13.7302 10.7466 13.6825 10.876C13.6349 11 13.5714 11.1132 13.4921 11.2156C13.4127 11.3181 13.3201 11.407 13.2143 11.4825C13.1138 11.558 13.0079 11.6199 12.8968 11.6685V11.6927C13.0344 11.7197 13.1667 11.7709 13.2937 11.8464C13.4259 11.9164 13.545 12.0108 13.6508 12.1294C13.7566 12.2426 13.8413 12.3801 13.9048 12.5418C13.9683 12.7035 14 12.8895 14 13.0997Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                      </svg>
                      <p
                        style={{
                          boxSizing: "border-box",
                          margin: "0px 0px 4px",
                          fontFamily: "Avenir",
                          fontSize: "18px",
                          lineHeight: "24px",
                          fontWeight: 800,
                        }}
                      >
                        Retrouvez-la
                      </p>
                      <p
                        style={{
                          boxSizing: "border-box",
                          margin: "0px",
                          fontFamily: "Avenir",
                          fontSize: "16px",
                          lineHeight: "22px",
                          fontWeight: 500,
                          textAlign: "center",
                        }}
                      >
                        au format PDF en pièce jointe d'un e-mail envoyé post
                        achat au titulaire de la carte.
                      </p>
                    </div>
                  </li>
                  <li style={{ boxSizing: "border-box", overflow: "hidden" }}>
                    <div
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        marginBottom: "24px",
                      }}
                    >
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        data-test="icon-4"
                        style={{
                          boxSizing: "border-box",
                          fill: "rgb(12, 19, 31)",
                          marginBottom: "16px",
                          height: "70px",
                          width: "4.375rem",
                        }}
                      >
                        <path
                          d="M12 2C6.49434 2 2 6.49438 2 12C2 17.5056 6.49434 22 12 22C17.5056 22 22 17.5056 22 12C22 6.49438 17.5056 2 12 2ZM12 20.8764C7.11232 20.8764 3.1236 16.8876 3.1236 12C3.1236 7.11236 7.11232 3.1236 12 3.1236C16.8876 3.1236 20.8764 7.11236 20.8764 12C20.8764 16.8876 16.8876 20.8764 12 20.8764Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M12.4264 9.96266L10.8527 12.8091H12.4264V9.96266ZM13.4031 13.7801V15H12.4264V13.7801H10V12.7261L12.1318 9H13.4031V12.7925H14V13.7801H13.4031Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                      </svg>
                      <p
                        style={{
                          boxSizing: "border-box",
                          margin: "0px 0px 4px",
                          fontFamily: "Avenir",
                          fontSize: "18px",
                          lineHeight: "24px",
                          fontWeight: 800,
                        }}
                      >
                        Économisez
                      </p>
                      <p
                        style={{
                          boxSizing: "border-box",
                          margin: "0px",
                          fontFamily: "Avenir",
                          fontSize: "16px",
                          lineHeight: "22px",
                          fontWeight: 500,
                          textAlign: "center",
                        }}
                      >
                        toute l'année grâce à ses réductions et multiples
                        avantages !
                      </p>
                    </div>
                  </li>
                </ol>
              </div>
              <div style={{ boxSizing: "border-box" }}>
                <div
                  style={{
                    boxSizing: "border-box",
                    WebkitBoxAlign: "center",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    marginBottom: "24px",
                    maxWidth: "628px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      boxSizing: "border-box",
                      color: "rgb(12, 19, 31)",
                      transition:
                        "box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      borderRadius: "14px",
                      overflow: "hidden",
                      boxShadow: "none",
                      border: "0px none rgb(12, 19, 31)",
                      background:
                        "rgb(255, 255, 255) none repeat scroll 0% 0% / auto padding-box border-box",
                      maxWidth: "328px",
                      height: "286px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        boxSizing: "border-box",
                        paddingBottom: "16px",
                        padding: "16px",
                        display: "flex",
                        flexDirection: "column",
                        WebkitBoxPack: "justify",
                        justifyContent: "space-between",
                        minHeight: "265px",
                      }}
                    >
                      <div style={{ boxSizing: "border-box" }}>
                        <h3
                          style={{
                            boxSizing: "border-box",
                            margin: "0px 0px 16px",
                            fontFamily: "Avenir",
                            fontSize: "18px",
                            lineHeight: "24px",
                            fontWeight: 800,
                          }}
                        >
                          Comment dématérialiser la carte ?
                        </h3>
                        <p
                          style={{
                            boxSizing: "border-box",
                            margin: "0px",
                            fontFamily: "Avenir",
                            fontSize: "16px",
                            lineHeight: "22px",
                            fontWeight: 500,
                          }}
                        >
                          Afin d'avoir tous vos supports de voyage (billets +
                          carte de réduction) dans un même QR code,
                          dématérialisez votre carte dès maintenant.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    boxSizing: "border-box",
                    WebkitBoxAlign: "center",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    marginBottom: "24px",
                    maxWidth: "628px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      boxSizing: "border-box",
                      color: "rgb(12, 19, 31)",
                      transition:
                        "box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      borderRadius: "14px",
                      overflow: "hidden",
                      boxShadow: "none",
                      border: "0px none rgb(12, 19, 31)",
                      background:
                        "rgb(255, 255, 255) none repeat scroll 0% 0% / auto padding-box border-box",
                      maxWidth: "328px",
                      height: "265px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        boxSizing: "border-box",
                        paddingBottom: "16px",
                        padding: "16px",
                        display: "flex",
                        flexDirection: "column",
                        WebkitBoxPack: "justify",
                        justifyContent: "space-between",
                        minHeight: "265px",
                      }}
                    >
                      <div style={{ boxSizing: "border-box" }}>
                        <h3
                          style={{
                            boxSizing: "border-box",
                            margin: "0px 0px 16px",
                            fontFamily: "Avenir",
                            fontSize: "18px",
                            lineHeight: "24px",
                            fontWeight: 800,
                          }}
                        >
                          Comparer nos différentes offres
                        </h3>
                        <p
                          style={{
                            boxSizing: "border-box",
                            margin: "0px",
                            fontFamily: "Avenir",
                            fontSize: "16px",
                            lineHeight: "22px",
                            fontWeight: 500,
                          }}
                        >
                          Parmi les multiples cartes et abonnements SNCF, nous
                          vous accompagnons dans votre choix, selon votre
                          profil.{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr
              aria-hidden="true"
              style={{
                boxSizing: "content-box",
                height: "8px",
                overflow: "visible",
                margin: "0px",
                flexShrink: 0,
                borderWidth: "0px",
                borderColor: "rgb(173, 255, 47)",
                backgroundColor: "rgb(255, 255, 255)",
                borderStyle: "none",
              }}
            />
            <div style={{ boxSizing: "border-box", paddingTop: "32px" }}>
              <h2
                style={{
                  boxSizing: "border-box",
                  margin: "0px 0px 16px",
                  fontFamily: "Avenir",
                  fontSize: "18px",
                  lineHeight: "24px",
                  fontWeight: 800,
                }}
              >
                Mentions légales
              </h2>
              <div
                style={{
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "column",
                  listStyle: "outside none none",
                  margin: "0px",
                  padding: "0px",
                }}
              >
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontWeight: 500,
                    }}
                  >
                    PRIX DE LA CARTE AVANTAGE SENIOR : 2,45 €
                  </h3>
                  <p
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "13px",
                      lineHeight: "18px",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    Carte réservée pour toute personne âgée plus de 60 ans
                    [CARTE AVANTAGE SENIOR] Prix de la Carte Avantage Senior 60
                    ans et + : 2,45 € Prix en vigueur au 12/08/2022, hors
                    promotions. Durée de validité : un an à partir de la date de
                    début de validité déterminée par le client lors de l’achat.
                  </p>
                </div>
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontWeight: 500,
                    }}
                  >
                    CONDITIONS D'UTILISATION
                  </h3>
                  <p
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "13px",
                      lineHeight: "18px",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    Si le bénéfice du tarif Avantage est conditionné au voyage
                    avec un enfant ou bambin, ce dernier devra être présent et
                    en possession d’un titre de transport valable (billet
                    accompagnant enfant ou tarif bambin) lors du contrôle à bord
                    du train. Un accompagnant (adulte ou enfant) ayant bénéficié
                    d’une réduction associée au tarif de la Carte Avantage devra
                    obligatoirement voyager avec le titulaire de la carte
                    Avantage correspondante.
                  </p>
                </div>
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontWeight: 500,
                    }}
                  >
                    30% DE RÉDUCTION POUR LES ADULTES{" "}
                  </h3>
                  <p
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "13px",
                      lineHeight: "18px",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    La Carte Avantage permet de bénéficier d’une réduction de
                    30% pour le titulaire Offre réservée aux titulaires de la
                    Carte Avantage. Réduction calculée, hors prestations
                    supplémentaires payantes, sur le tarif PREM’S, SECONDE,
                    PREMIÈRE et le Plein Tarif SECONDE et PREMIÈRE pour les
                    trains à réservation obligatoire (TGV INOUI et INTERCITÉS,
                    hors OUIGO) et pour les trains INTERCITÉS sans réservation
                    obligatoire. Réductions applicables sur le territoire
                    national. Les conditions d’application sur TER sont de la
                    responsabilité des autorités organisatrices et sont
                    disponibles sur les sites Internet TER.
                  </p>
                </div>
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontWeight: 500,
                    }}
                  >
                    60% DE RÉDUCTION POUR LES ENFANTS
                  </h3>
                  <p
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "13px",
                      lineHeight: "18px",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    La carte permet de bénéficier d’une réduction de 60% pour
                    les enfants accompagnants. Offre réservée jusqu’à 3
                    accompagnateurs enfants de 4 à 11 ans inclus si le billet
                    est acheté simultanément au billet du titulaire de la carte
                    Avantage. Réduction calculée, hors prestations
                    supplémentaires payantes, sur le tarif PREM’S, SECONDE,
                    PREMIÈRE et le Plein Tarif SECONDE et PREMIÈRE pour les
                    trains à réservation obligatoire (TGV INOUI et INTERCITÉS,
                    hors OUIGO) et pour les trains INTERCITÉS sans réservation
                    obligatoire. Réductions applicables sur le territoire
                    national. Si le bénéfice du tarif Avantage est conditionné
                    au voyage avec un enfant ou un bambin (enfant de moins de 4
                    ans), ce dernier devra être présent lors du contrôle à bord
                    du train. Un accompagnant (adulte ou enfant) ayant bénéficié
                    d’une réduction associée au tarif de la Carte Avantage devra
                    obligatoirement voyager avec le titulaire de la carte
                    Avantage correspondante.
                  </p>
                </div>
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontWeight: 500,
                    }}
                  >
                    15% DE RÉDUCTION SUR LES SERVICES
                  </h3>
                  <p
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "13px",
                      lineHeight: "18px",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    La Carte Avantage permet une réduction de 15% sur les
                    services Ma Location Avis, Mes Bagages, La restauration à
                    bord et Junior &amp; Cie. Offres soumises à conditions.
                    Informations sur les services disponibles sur
                    sncf-voyageurs.com. Ma Location Avis Les détenteurs d’une
                    Carte Avantage bénéficient de 15% de réduction. Offre
                    soumise à conditions, valable sur les tarifs prépayés AVIS
                    et BUDGET France grand public, pour des départs en France
                    continentale (hors Corse), pour toutes locations de 1 à 30
                    jours. Remise accessible pour un paiement à la réservation
                    pour toute catégorie de véhicule hors AVIS Prestige, AVIS
                    Select Séries et les véhicules utilitaires AVIS. Les remises
                    sont calculées sur un prix AVIS ou BUDGET hors surcharge,
                    hors complément de protection et hors assurance. Offre
                    valable sous réserve de disponibilité des véhicules au
                    moment de la location. Plus d'informations sur
                    https://secure.malocationavis.sncf-connect.com/ Mes bagages
                    Réduction de 15% sur la commande du service Mes Bagages avec
                    une Carte Avantage. Offre valable dès le 1er bagage (hors
                    fauteuils roulants) sur internet
                    (mesbagages.sncf-connect.com), par téléphone au 3635
                    (service gratuit + prix appel) et en gare et boutiques SNCF.
                    La restauration à bord 15% de réduction sur toutes les
                    formules et menus. Réduction valable sur présentation de
                    votre Carte Avantage en cours de validité (sans limitation
                    du nombre de passage au Bar) ou d’un tarif Avantage précisé
                    sur votre billet. Pour les enfants de 4 à 11 ans
                    accompagnateurs d’un titulaire de Carte Avantage : offre
                    exclusive « Goûter Avantage » (Jus de pomme ou eau plate +
                    cookie ou M&amp;M’s® + yaourt au choix) au prix de 5€, en
                    présence de l’enfant ou sur présentation de son titre de
                    transport. Offre valable sur l’ensemble du réseau national
                    TGV INOUI (hors TGV France-Italie, TGV France-Espagne, TGV
                    France-Luxembourg, DB-SNCF VOYAGEURS en Coopération et TGV
                    Lyria). Junior &amp; cie Si le client possède une Carte
                    Avantage, il bénéficie de 15% de réduction sur le forfait,
                    valable pour un voyage de 1 à 3 enfants. Cet avantage n'est
                    ni cumulable avec l’avantage Carte Famille Nombreuse ni avec
                    un code promotionnel.
                  </p>
                </div>
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontWeight: 500,
                    }}
                  >
                    PRIX PLAFONNÉS
                  </h3>
                  <p
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "13px",
                      lineHeight: "18px",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    Garantie d’un prix plafonné par trajet sur TGV INOUI et
                    INTERCITÉS (de jour et places assises de nuit) en fonction
                    du temps moyen observé sur un trajet sans correspondance. •
                    2,45 € TTC : Prix maximum garanti d’un billet pour un trajet de
                    moins de 1H30, • 69€ TTC : Prix maximum garanti d’un billet
                    pour un trajet entre 1H30 et 3H, • 89€ TTC : Prix maximum
                    garanti d’un billet pour un trajet de plus de 3H en France
                    en seconde classe. Prix fixe jusqu’au départ du train. En
                    France en seconde classe sur un trajet sans correspondance.
                    Prix fixe jusqu’au départ du train. Prix valables jusqu’au
                    31/08/2024.
                  </p>
                </div>
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontWeight: 500,
                    }}
                  >
                    CARTE RENTABILISÉE DES LE 3e VOYAGE
                  </h3>
                  <p
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "13px",
                      lineHeight: "18px",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    Amortissement constaté dès le troisième trajet (trajet
                    simple d’une destination initiale à une destination finale),
                    sur la base des réductions appliquées aux titulaires d’une
                    Carte Avantage (Jeune, Adulte ou Senior) et aux potentiels
                    accompagnants (au prorata des voyages accompagnés), en 1re
                    et 2de classe, sur toutes les destinations TGV INOUI et
                    INTERCITÉS confondues (hors TER), entre le 01/01/2022 et le
                    31/05/2022.
                  </p>
                </div>
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontWeight: 500,
                    }}
                  >
                    LES RÉDUCTIONS SUR TER{" "}
                  </h3>
                  <p
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "13px",
                      lineHeight: "18px",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    Dans les TER, la carte permet de bénéficier d’une réduction
                    de 25, 30 ou 50%, selon les régions, le calendrier
                    voyageurs, garantis toute l’année sous réserve qu’elle soit
                    acceptée par l’autorité organisatrice des transports
                    régionaux sur son périmètre. Information disponible sur les
                    sites régionaux TER.
                  </p>
                </div>
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontWeight: 500,
                    }}
                  >
                    LES RÉDUCTIONS EN EUROPE{" "}
                  </h3>
                  <p
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "13px",
                      lineHeight: "18px",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    La Carte Avantage est valable pour des voyages en France et
                    en Europe. Offre réservée aux titulaires de la carte
                    Avantage. Réduction calculée, hors prestations
                    supplémentaires payantes • sur le tarif SECONDE ou PREMIÈRE
                    du jour sur les trains TGV INOUI à destination du
                    Luxembourg, l’Italie, l’Espagne, • sur les trains TGV INOUI
                    et ICE de DB-SNCF VOYAGEURS en Coopération vers
                    Fribourg-en-Brigsau, • sur le tarif STANDARD ou STANDARD
                    1ÈRE des trains TGV Lyria. Offre valable pour un
                    accompagnateur adulte et enfant pour les titulaires de la
                    carte Adulte 27-59 ans.
                  </p>
                </div>
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontWeight: 500,
                    }}
                  >
                    LES TARIFS NO FLEX
                  </h3>
                  <p
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "13px",
                      lineHeight: "18px",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    La carte permet d’accéder à des offres de dernière minute NO
                    FLEX. Offre disponible en dernière minute accessible dans
                    les trains TGV INOUI, INTERCITÉS à réservation obligatoire
                    et INTERCITÉS sans réservation obligatoire. Offre réservée
                    au titulaire de la Carte Avantage et jusqu’à 3 accompagnants
                    enfants âgés de 4 à 11 ans inclus à condition de voyager
                    dans le même train et la même classe. L’achat des billets NO
                    FLEX du titulaire et des accompagnants doit être simultané.
                    L’offre NO FLEX est disponible sur une sélection de
                    destinations en France et en Europe, certains jours et dans
                    certains trains dans la limite des places disponibles. Offre
                    non cumulable avec toute autre promotion en cours ou tarif
                    réduit SNCF ou Partenaires européens. Offre non échangeable
                    et non remboursable.
                  </p>
                </div>
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontWeight: 500,
                    }}
                  >
                    ÉCHANGE ET REMBOURSEMENT DES BILLETS AU TARIF AVANTAGE{" "}
                  </h3>
                  <p
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "13px",
                      lineHeight: "18px",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    Conditions d’échange et de remboursement d’un billet avec la
                    Carte Avantage sur les trains TGV INOUI et INTERCITÉS à
                    réservation obligatoire. • Service d’échange et de
                    remboursement proposé gratuitement jusqu’à 7 jours inclus
                    avant départ. • Dès 6 jours, avant le départ, retenue de
                    19€ par personne et par trajet appliquée sur TGV INOUI et de
                    40% du prix du billet avec retenue maximum de 15€ sur
                    INTERCITÉS à réservation obligatoire. • 30 min avant départ
                    et jusqu’au départ, échange possible (1 maximum) avec la
                    même retenue qu’énoncée précédemment. Les billets échangés
                    dans ce laps de temps sont non remboursables. • La retenue
                    n’est appliquée qu’une fois, pour les trajets comprenant une
                    ou plusieurs correspondances. • Billet non échangeable et
                    non remboursable après le départ du train, sauf si celui-ci
                    a été remis à disposition avant départ.
                  </p>
                </div>
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontWeight: 500,
                    }}
                  >
                    DROIT A LA RÉTRACTATION SUITE A L’ACHAT D’UNE CARTE AVANTAGE
                  </h3>
                  <p
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "13px",
                      lineHeight: "18px",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    Le droit de rétractation des articles L.221-18 à L.221-28 du
                    Code de la consommation permettant de changer d’avis dans un
                    délai de 14 jours après la date d'achat de la carte si le
                    client n'a pas voyagé avec une réduction offerte par la
                    Carte Avantage s’applique. Ainsi, passé le délai de 14 jours
                    après achat, la demande du droit de rétractation n’est plus
                    recevable et la carte n’est plus remboursable même si la
                    date de début de validité n’est pas passée.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
